import { Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Strings } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { useResponsive } from "@app/hooks";

const FooterLinks = () => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "md");
  const navigate = useNavigate();

  return (
    <Stack spacing={1}>
      <Typography
        fontWeight="400"
        sx={{ cursor: "pointer", fontFamily: "Work Sans" }}
        color={theme.palette.common.white}
        fontSize={"10"}
        onClick={() => navigate(PATH_DASHBOARD.productListPage)}
      >
        {Strings.footer.products}
      </Typography>
      <Typography
        fontWeight="400"
        sx={{ cursor: "pointer", fontFamily: "Work Sans" }}
        color={theme.palette.common.white}
        fontSize={"10"}
        onClick={() => navigate(PATH_DASHBOARD.productListPage)}
      >
        {Strings.footer.category}
      </Typography>
      <Typography
        fontWeight="400"
        sx={{ cursor: "pointer", fontFamily: "Work Sans" }}
        color={theme.palette.common.white}
        fontSize={"10"}
        onClick={() => navigate("#")}
      >
        {Strings.footer.contactUs}
      </Typography>
    </Stack>
  );
};

export { FooterLinks };
